var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { style: { height: "100%" }, attrs: { xs: "12", md: "4", xl: "3" } },
    [
      _c(
        "w-scroll-view",
        { style: { height: "100%" }, attrs: { tag: "w-card" } },
        [
          _c("w-card-title", { key: "my-folders-title" }, [
            _vm._v(" " + _vm._s(_vm.$ct("my-folders")) + " "),
          ]),
          _c(
            "div",
            [
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.myFolders,
                    "disable-x": "",
                    "keep-in-y": "",
                    tag: "w-list",
                    "target-class": "handle",
                  },
                  on: {
                    drop: function ($event) {
                      return _vm.onOwnedOrderDrop()
                    },
                  },
                },
                _vm._l(_vm.myFolders, function (folder) {
                  return _c(
                    "w-list-item",
                    {
                      key: folder.ID,
                      ref: "ownedItems",
                      refInFor: true,
                      class: { active: folder.ID == _vm.folderId },
                      attrs: { "show-handle": "" },
                      on: {
                        click: function ($event) {
                          return _vm.openFolder(folder)
                        },
                      },
                      nativeOn: {
                        mouseup: function ($event) {
                          return _vm.onFolderMouseUp(folder)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [_vm._v(_vm._s(folder.Name))]),
                      folder.ID == _vm.folderId
                        ? _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-dropdown",
                                {
                                  staticClass: "drop-down",
                                  attrs: {
                                    items: _vm.options,
                                    "trigger-class": "center",
                                    right: "",
                                    center: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return $event(folder)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "bars" } })],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            {
              key: "add-new-button",
              on: {
                click: function ($event) {
                  return _vm.openNewFolderModal()
                },
              },
            },
            [
              _c("w-list-item-text", [
                _c(
                  "span",
                  [
                    _c("w-fa", { attrs: { icon: "plus" } }),
                    _vm._v(" " + _vm._s(_vm.$ct("new-folder"))),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("w-card-title", { key: "shared-folders-title" }, [
            _vm._v(" " + _vm._s(_vm.$ct("shared-folders")) + " "),
          ]),
          _c(
            "w-sortable",
            {
              attrs: {
                items: _vm.sharedFolders,
                "disable-x": "",
                "keep-in-y": "",
                tag: "w-list",
                "target-class": "handle",
              },
              on: {
                drop: function ($event) {
                  return _vm.onSharedOrderDrop()
                },
              },
            },
            _vm._l(_vm.sharedFolders, function (folder) {
              return _c(
                "w-list-item",
                {
                  key: folder.ID,
                  attrs: { "show-handle": "" },
                  on: {
                    click: function ($event) {
                      return _vm.openFolder(folder)
                    },
                  },
                },
                [_c("w-list-item-text", [_vm._v(_vm._s(folder.Name))])],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.newFolderModal,
            callback: function ($$v) {
              _vm.newFolderModal = $$v
            },
            expression: "newFolderModal",
          },
        },
        [
          _c("app-new-folder-modal", {
            on: {
              close: function ($event) {
                _vm.newFolderModal = false
              },
              created: function ($event) {
                return _vm.onNewFolder($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.editFolderModal,
            callback: function ($$v) {
              _vm.editFolderModal = $$v
            },
            expression: "editFolderModal",
          },
        },
        [
          _vm.toEditFolder
            ? _c("app-edit-folder", {
                attrs: { folder: _vm.toEditFolder },
                on: {
                  "update:folder": function ($event) {
                    _vm.toEditFolder = $event
                  },
                  close: function ($event) {
                    _vm.editFolderModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.repeatedTaskListFolder
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-repeated-task-list", {
                attrs: { folder: _vm.repeatedTaskListFolder },
                on: {
                  close: function ($event) {
                    _vm.repeatedTaskListFolder = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }